module.exports = __webpack_public_path__ + "img/notification.0ee9d3be.svg";